// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.use(ElementUI)
// 根据类型跳转
Vue.prototype.$navToByType = function (item) {
  console.log(item)
  if (item.val) {
    if (item.type === 'article') {
      this.$handleArticle(item.val)
    } else if(item.type === 'link') {
      this.$navOpen(item.val)
    } else if(item.type === 'exam') {
      this.$handleExam(item.val)
    }
  }
}
Vue.prototype.$locTo = function (url) {
  if (url) {
    window.location.href = url
  }
}
// 路由跳转
Vue.prototype.$navTo = function (routeName, params= {}) {
  console.log(routeName)
  if (this.$route.name !== routeName) {
    this.$router.push({name: routeName, query: params})
  }
}
// 外链打开
Vue.prototype.$navOpen = function (url) {
  if (url) {
    window.open(url)
  }
}
// 文章详情跳转
Vue.prototype.$handleArticle = function (aid){
  if (aid > 0) {
    this.$router.push({name: 'articleDetail', query: {id: aid}})
    // this.$locTo('https://www.falvren.net/article/detail?id=' + aid);
  }
}
// 课程详情跳转
Vue.prototype.$handleCourse = function (cid){
  if (cid > 0) {
    this.$router.push({name: 'courseDetail', query: {id: cid}})
  }
}
// 文章列表跳转
Vue.prototype.$handleArticleList = function (params){
  this.$router.push({name: 'article', query: params})
}
// 考试练习跳转
Vue.prototype.$handleExam = function (eid){
  this.$router.push({name: 'examSearchDetail', query: {id: eid}})
}
// 退出登录
Vue.prototype.$logout = function (){
  ElementUI.MessageBox.confirm('确认退出登录吗?', '').then(()=>{
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    window.location.reload()
  })
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js